import request from '@/utils/httpRequest'

// 获取文章分页列表
export function getVersionList (params) {
  return request({
    url: `/app_version/list_page`,
    method: 'get',
    params
  })
}

export const updateUrl = '/qtSysapi/app_version/add'
